//@ts-nocheck
import { LandscapeWrap, GlobalStyle } from './Landscape.styles';
import { ReactComponent as BlackIco } from '@assets/icons/blackIco.svg';
import { RotateIcon } from '@assets/svgs';

export enum LandscapeVariants {
  WHITE = 'white',
  BLACK = 'black'
}

type LandscapeProps = {
  children: React.ReactNode;
  variant?: LandscapeVariants;
  hideError?: boolean;
};

const Landscape = ({ children, variant, hideError }: LandscapeProps) => {
  return (
    <>
      {!hideError ? (
        <LandscapeWrap className={variant}>
          <div>
            <span className="blackIco">
              <RotateIcon />
            </span>
            <span>Please</span>
            <h2>Rotate Your Device</h2>
            <span className="bottomText">to continue</span>
          </div>
        </LandscapeWrap>
      ) : (
        <></>
      )}
      {children}
    </>
  );
};

export default Landscape;
